/* tslint:disable:no-unused-expression */
import { Grid, Theme, withStyles, WithStyles } from '@material-ui/core';
import withTheme from '@material-ui/core/styles/withTheme';
import { IJackpotStatus } from '@pbl/pbl-react-core/lib/models/games/types';
import { CardContentLoader, LoadError } from '@pbl/pbl-react-web-components/lib/package';
import constants, { RemoteConstants } from 'config/constants';
import _ from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { IRootState } from 'redux/reducers';
import {
  getJackpotResultByDraw,
  getLatestJackpotResult,
  getLatestJackpotResultByDraw,
  getMultipleDrawsPayout,
  getNextJackpotResultByDraw,
  resetJackpot,
  sendPlayerTicketDataForJackpot
} from 'redux/reducers/games/actions';
import { styles } from './KenoStyles';

export interface IScreenProps extends StateProps, DispatchProps, WithStyles<typeof styles> {
  theme: Theme;
}

interface IScreenState {
  loading: boolean;
  showError: boolean;
  lastValidExternalId: string;
  autoPlayValue: boolean;
  gameIsPlaying: boolean;
  kenoVersion: string;
}

class KenoScreen extends React.Component<IScreenProps, IScreenState> {
  private intervalEvent;
  private timeoutEvent;
  constructor(props: IScreenProps) {
    super(props);
    this.state = {
      showError: false,
      loading: false,
      lastValidExternalId: '',
      autoPlayValue: false,
      gameIsPlaying: false,
      kenoVersion: '0.0.0'
    };
    window.addEventListener('message', this.receiveMessage, false);
  }

  public async componentDidMount() {
    this.setState({ autoPlayValue: await RemoteConstants.getBoolean('KENO_AUTOPLAY') });
    const kenoVersion = await RemoteConstants.getString('KENO_VERSION');
    this.setState({ kenoVersion });
    await this.getEntities();
  }
  public componentWillUnmount() {
    window.removeEventListener('message', this.receiveMessage);
  }
  public async componentDidUpdate(prevProps: Readonly<IScreenProps>): Promise<void> {
    if (
      (!!this.props.games.jackpotResult && !prevProps.games.jackpotResult) ||
      (this.props.games.jackpotResult &&
        prevProps.games.jackpotResult &&
        this.props.games.jackpotResult.externalId !== prevProps.games.jackpotResult.externalId) ||
      (this.props.games.jackpotResult &&
        prevProps.games.jackpotResult &&
        this.props.games.jackpotResult.externalId === prevProps.games.jackpotResult.externalId &&
        this.props.games.jackpotResult.jackpotStatus !== prevProps.games.jackpotResult.jackpotStatus)
    ) {
      // @ts-ignore
      if (this.props.games.jackpotResult.jackpotStatus === IJackpotStatus[IJackpotStatus.PAYABLE]) {
        this.setState({ lastValidExternalId: this.props.games.jackpotResult.externalId });
      }

      this.stopCheckingForNewGame();
      await this.checkLatestDrawInfo();
      await this.updateIframe();
    }
    if (
      !!this.props.games.errorMessage &&
      !_.isEqual(prevProps.games.errorMessage, this.props.games.errorMessage) &&
      !!this.props.games.errorMessage.additionalInformation &&
      !!this.props.games.errorMessage.additionalInformation.keno
    ) {
      this.stopCheckingForNewGame();
      await this.checkLatestDrawInfo();
      await this.updateIframe();
    }
  }
  public async getEntities(id?: number) {
    if (this.state.gameIsPlaying) return;
    if (id) {
      await this.props.getJackpotResultByDraw(constants.KENO_ID, id);
    } else {
      await this.props.getLatestJackpotResult(constants.KENO_ID);
    }
  }

  public async getNextDrawStatus(id: number) {
    await this.props.getNextJackpotResultByDraw(constants.KENO_ID, id);
  }

  public async checkLatestDrawInfo() {
    await this.props.getLatestJackpotResultByDraw(constants.KENO_ID);
  }

  public async checkNextDrawStatus(id: number) {
    await this.getNextDrawStatus(id);
    this.updateIframeWithNextDrawInfo(this.props.games.nextDraw);
  }

  public async checkForNewGame() {
    this.stopCheckingForNewGame();
    let id = this.getDrawId();
    await this.getNextDrawStatus(++id);
    const pollingInterval = await RemoteConstants.getNumber('KENO_POLLING_INTERVAL');

    if (
      this.props.games.nextDraw &&
      this.props.games.nextDraw.jackpotResult &&
      // @ts-ignore
      this.props.games.nextDraw.jackpotResult.jackpotStatus === IJackpotStatus[IJackpotStatus.PAYABLE]
    ) {
      if (this.state.autoPlayValue) {
        await this.getEntities();
      } else {
        await this.getEntities(this.getDrawId() + 1);
      }
      return;
    }

    const now = Date.now();
    const nextDrawDate = this.props.games.jackpotResult ? Date.parse(this.props.games.jackpotResult.drawDate) : new Date();
    const timeoutBuffer = await RemoteConstants.getNumber('KENO_TIMOUT_BUFFER');
    // @ts-ignore
    const timout = Math.max(0, nextDrawDate - now + timeoutBuffer);
    console.warn(
      '************keno************ Next draw will be finished in ' + timout / 1000 + ' sec (Buffer: ' + timeoutBuffer / 1000 + ' sec)'
    );
    if (!this.timeoutEvent) {
      this.timeoutEvent = setTimeout(async () => {
        const nextDrawId = this.getDrawId() + 1;
        await this.getNextDrawStatus(nextDrawId);
        console.warn('************keno************ Fetching next draw (NextDrawId: ' + nextDrawId + ') timeout');
        console.warn(
          '************keno************ Start requesting server for new game every ' + pollingInterval / 1000 + ' sec',
          this.state.autoPlayValue
        );
        if (!this.intervalEvent) {
          this.intervalEvent = setInterval(async () => {
            if (
              this.props.games.nextDraw &&
              this.props.games.nextDraw.jackpotResult &&
              // @ts-ignore
              this.props.games.nextDraw.jackpotResult.jackpotStatus === IJackpotStatus[IJackpotStatus.PAYABLE]
            ) {
              await this.getEntities(this.getDrawId() + 1);
              this.stopCheckingForNewGame();
              return;
            }
            const drawId = this.getDrawId() + 1;
            await this.getNextDrawStatus(drawId);
            console.warn('************keno************ Fetching next draw (NextDrawId: ' + drawId + ') interval');
          }, pollingInterval);
        }
      }, timout);
    }
  }
  private getDrawId() {
    if (!!this.state.lastValidExternalId) {
      return parseInt(this.state.lastValidExternalId, 10);
    } else {
      return parseInt(this.props.games.jackpotResult.externalId, 10);
    }
  }
  public async stopCheckingForNewGame() {
    console.warn(
      '************keno************ Stop requesting server for new game every ' +
        (await RemoteConstants.getNumber('KENO_POLLING_INTERVAL')) / 1000 +
        ' sec'
    );
    clearInterval(this.intervalEvent);
    clearTimeout(this.timeoutEvent);
    this.intervalEvent = undefined;
    this.timeoutEvent = undefined;
  }
  public async sendPlayerEntry(data) {
    if (data.draws) {
      await this.props.getMultipleDrawsPayout(constants.KENO_ID, data.draws, data.playerSpots, data.ticketCost, response =>
        this.updateIframeWithWinningMessage(response)
      );
    } else {
      await this.props.sendPlayerTicketDataForJackpot(constants.KENO_ID, data.drawId, data.playerSpots, data.ticketCost, response =>
        this.updateIframeWithWinningMessage(response)
      );
    }
  }

  public async getLatestGame() {
    await this.props.getLatestJackpotResult(constants.KENO_ID, response => this.updateIframeWithLatestGame(response));
  }

  private receiveMessage = (event: any) => {
    try {
      const data = JSON.parse(event.data);
      if (!data || data.type !== 'poGame') return;
      switch (data.name) {
        case 'onGameResultHandler': {
          return console.warn('***** onGameResultHandler ', data.data);
        }
        case 'onGameStartHandler': {
          this.setState({ gameIsPlaying: true });
          this.stopCheckingForNewGame();
          return console.warn('***** onGameStartHandler');
        }
        case 'onGameReadyHandler': {
          this.setState({ gameIsPlaying: false });
          this.props.resetJackpot();
          this.getEntities();
          return console.warn('***** onGameReadyHandler');
        }
        case 'onLatestGameHandler': {
          this.setState({ autoPlayValue: false });
          this.getLatestGame();
          return console.warn('***** onLatestGameHandler');
        }
        case 'onGameEndHandler': {
          this.setState({ autoPlayValue: data.data, gameIsPlaying: false });
          this.checkNextDrawStatus(this.getDrawId() + 1);
          // @ts-ignore
          if (data.data || this.props.games.jackpotResult.jackpotStatus === IJackpotStatus[IJackpotStatus.OPEN]) {
            this.checkForNewGame();
          }
          return console.warn('***** onGameEndHandler', data.data);
        }
        case 'updateAutoPlayHandler': {
          this.setState({ autoPlayValue: data.data });
          this.checkNextDrawStatus(this.getDrawId() + 1);
          if (data.data) {
            this.checkForNewGame();
          } else {
            this.stopCheckingForNewGame();
          }
          return console.warn('***** onGameEndHandler', data.data);
        }
        case 'onGameExitHandler': {
          return console.warn('***** onGameExitHandler');
        }
        case 'onGameErrorHandler': {
          return console.warn('***** onGameErrorHandler ', data.data);
        }
        case 'onEnterTicketHandler': {
          this.setState({ gameIsPlaying: false });
          this.sendPlayerEntry(data.data);
          return console.warn('***** onEnterTicketHandler ', data.data);
        }
        case 'onPreviousGameHandler': {
          this.setState({ gameIsPlaying: false });
          let id = parseInt(this.props.games.jackpotResult.externalId, 10);
          this.getEntities(--id);
          return console.warn('***** onPreviousGameHandler', id, this.props.games.jackpotResult.externalId);
        }
        case 'onNextGameHandler': {
          this.setState({ gameIsPlaying: false });
          let id = this.getDrawId();
          this.getEntities(++id);
          return console.warn('***** onNextGameHandler ');
        }
        default:
          return;
      }
    } catch {}
  };
  private updateIframe = async () => {
    const kenoAutoplay = await RemoteConstants.getBoolean('KENO_AUTOPLAY');
    const kenoPlayDelay = await RemoteConstants.getNumber('KENO_AUTOPLAY_DELAY');
    this.setState({ gameIsPlaying: true });
    // @ts-ignore
    document.getElementById('iframe').contentWindow.postMessage(
      JSON.stringify({
        type: 'poGameParent',
        name: 'setGameConfig',
        data: {
          latestDrawNumber:
            this.props.games.latestDraw && this.props.games.latestDraw.jackpotResult
              ? this.props.games.latestDraw.jackpotResult.externalId
              : null,
          latestDrawStatus:
            this.props.games.latestDraw && this.props.games.latestDraw.jackpotResult
              ? this.props.games.latestDraw.jackpotResult.jackpotStatus
              : 'PAYABLE',
          drawNumber: this.props.games.jackpotResult ? this.props.games.jackpotResult.externalId : null,
          gameNumbers:
            // @ts-ignore
            this.props.games.jackpotResult && this.props.games.jackpotResult.jackpotStatus === IJackpotStatus[IJackpotStatus.PAYABLE]
              ? this.props.games.gameNumbers
              : [],
          jackpotStatus:
            // @ts-ignore
            this.props.games.jackpotResult && this.props.games.jackpotResult.jackpotStatus === IJackpotStatus[IJackpotStatus.PAYABLE]
              ? this.props.games.jackpotResult.jackpotStatus
              : 'OPEN',
          multiplier: this.props.games.jackpotResult ? this.props.games.jackpotResult.multiplier : null,
          autoPlayDefault: kenoAutoplay,
          autoPlayDelay: kenoPlayDelay,
          assetsBaseUrl: constants.KENO_ASSETS_BASE_URL,
          errorMsg:
            !!this.props.games.errorMessage &&
            !!this.props.games.errorMessage.additionalInformation &&
            !!this.props.games.errorMessage.additionalInformation.keno
              ? this.props.games.errorMessage.additionalInformation.keno
              : null,
          drawDate: this.props.games.jackpotResult ? this.props.games.jackpotResult.drawDate : null
        }
      }),
      '*'
    );

    this.setState({
      loading: false
    });
  };
  private updateIframeWithLatestGame = data => {
    this.setState({ gameIsPlaying: true });
    // @ts-ignore
    document.getElementById('iframe').contentWindow.postMessage(
      JSON.stringify({
        type: 'poGameParent',
        name: 'setLatestGame',
        data: {
          drawNumber: data.jackpotResult ? data.jackpotResult.externalId : null,
          errorMsg:
            !!this.props.games.errorMessage &&
            !!this.props.games.errorMessage.additionalInformation &&
            !!this.props.games.errorMessage.additionalInformation.keno
              ? this.props.games.errorMessage.additionalInformation.keno
              : null
        }
      }),
      '*'
    );
  };
  private updateIframeWithNextDrawInfo = data => {
    // @ts-ignore
    document.getElementById('iframe').contentWindow.postMessage(
      JSON.stringify({
        type: 'poGameParent',
        name: 'setNextDrawInfo',
        data: {
          nextDrawNumber: data.jackpotResult ? data.jackpotResult.externalId : null,
          nextDrawStatus: data.jackpotResult ? data.jackpotResult.jackpotStatus : null,
          errorMsg:
            !!this.props.games.errorMessage &&
            !!this.props.games.errorMessage.additionalInformation &&
            !!this.props.games.errorMessage.additionalInformation.keno
              ? this.props.games.errorMessage.additionalInformation.keno
              : null
        }
      }),
      '*'
    );
  };

  private updateIframeWithWinningMessage = response => {
    // @ts-ignore
    document.getElementById('iframe').contentWindow.postMessage(
      JSON.stringify({
        type: 'poGameParent',
        name: 'updatePayout',
        data: response
      }),
      '*'
    );

    this.setState({
      loading: false
    });
  };
  public render() {
    const { loading, showError } = this.state;
    if (showError) {
      return <LoadError onReloadIconPress={this.getEntities.bind(this)} text="Something went wrong while loading the content!" />;
    }

    if (loading) {
      const contentLoader = (
        <Grid item xs={12} sm={6} md={4}>
          <CardContentLoader loaderStyle={'loyalty'} />
        </Grid>
      );

      return (
        <div style={{ display: 'flex', flexDirection: 'column', margin: 16, maxWidth: 850 }}>
          <Grid container spacing={4}>
            {contentLoader}
          </Grid>
        </div>
      );
    }
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: 850,
        }}
        className={this.props.classes.screenSize}
      >
        <iframe
          style={{ height: '100%', width: '100%' }}
          className={this.props.classes.root}
          src={constants.KENO_GAME_URL + '?v=' + this.state.kenoVersion}
          id={'iframe'}
          onLoad={this.updateIframe}
          allow="autoplay"
        />
      </div>
    );
  }
}

const mapStateToProps = ({ games }: IRootState) => ({ games });

// @ts-ignore
const mapDispatchToProps = {
  getLatestJackpotResult,
  getJackpotResultByDraw,
  sendPlayerTicketDataForJackpot,
  resetJackpot,
  getMultipleDrawsPayout,
  getNextJackpotResultByDraw,
  getLatestJackpotResultByDraw
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(withStyles(styles)(KenoScreen)));
